(function () {
    'use strict';

    angular.module('app.shared.services').constant('TemplateAccessConstants', {
        /**
         * Access Restriction Modes
         * Defines the different access levels that can be assigned to team members for entity
         */
        ACCESS_RESTRICTION: {
            LISTED: 0, // 📋 LISTED - Only explicitly assigned (default)
            FULL_ACCESS: 1, // 🌐 FULL ACCESS - All entities without restrictions
            ALL_READ_ONLY_PLUS_LISTED: 2 // 👁️ ALL READ-ONLY + LISTED - Read all, edit listed
        },

        /**
         * Access Level Types for entities
         */
        ACCESS_LEVEL_TYPES: {
            NONE: 0,
            LIST: 1, // Can list/see entity
            READ: 2, // Can view entity
            WRITE: 4, // Can edit/save entity
            DELETE: 8, // Can delete entity
            FULL: 15 // Full permissions
        },

        ENTITY_TYPE: {
            TEMPLATE: 0,
            LIBRARY: 1,
            DESIGN: 2,
            OPTION_SET: 3,
            PRODUCT: 4,
            STORE: 5,
            INTEGRATIONS: 6
        }
    });
})();
